module.exports = __webpack_public_path__ + "../resources/images/illustration_sent-566f54cbbfddea4aa8d119539771bfe6.svg";